import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const CultureFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M12.0001 3.35938L3.6001 9.35938H20.4001L12.0001 3.35938ZM11.1001 10.7998L11.1001 16.7998H12.9001V10.7998H11.1001ZM19.2 18.2998H4.80005V20.0998H19.2V18.2998ZM15.9001 16.7998V10.7998H17.7001V16.7998H15.9001ZM6.30005 10.7998L6.30005 16.7998H8.10005V10.7998H6.30005Z"
      />
    </SvgIcon>
  );
});
